module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Marker2-aeb947eafb71abe84c9befbce804cbb9.svg";